import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { isEqual } from 'lodash';
import { SortDirection } from '../../types';

const SORT_BY_KEY = 'sortBy';
const SORT_DIRECTION_KEY = 'sortDirection';

export type SortResult = {
    order: SortDirection;
    field: string;
};

export const useSorter = () => {
    const [prevSorter, setPrevSorter] = useState<SortResult | SortResult[]>();
    const [searchParams, setSearchParams] = useSearchParams();

    const sortBySearchParam = searchParams.get(SORT_BY_KEY) || undefined;
    const sortDirectionSearchParam =
        (searchParams.get(SORT_DIRECTION_KEY) as SortDirection) || undefined;

    const deleteSorting = () => {
        setSearchParams((prevSearchParams) => {
            prevSearchParams.delete(SORT_BY_KEY);
            prevSearchParams.delete(SORT_DIRECTION_KEY);
            return prevSearchParams;
        });
    };

    const handleSorterChange = (sorter?: string) => {
        if (isEqual(prevSorter, sorter)) {
            return;
        }

        if (!sorter) {
            deleteSorting();
            return;
        }

        const [field, order] = sorter.split('_') as [string, SortDirection];

        setPrevSorter({ field, order });

        if (field && order) {
            setSearchParams(
                (prevSearchParams) => {
                    prevSearchParams.set(SORT_BY_KEY, field.toString());
                    prevSearchParams.set(SORT_DIRECTION_KEY, order);

                    return prevSearchParams;
                },
                { replace: true },
            );
        } else {
            deleteSorting();
        }
    };

    return {
        sortData: { order: sortDirectionSearchParam, field: sortBySearchParam },
        handleSorterChange,
    };
};
